export enum AppEnvironment {
  Unknown = 1,
  Development,
  Testing,
  Staging,
  Production
}

export enum Status {
  Unknown,
  Draft,
  Active,
  Inactive
}

export enum UserType {
  Unknown,
  Donor,
  Consignor
}

export enum DonationStatus {
  Unknown = 0,
  Scheduled,
  CheckedIn,
  Completed,
  Cancelled,
  NoShow
}

export const AppEnvironmentLabel: Record<AppEnvironment, string> = {
  [AppEnvironment.Unknown]: 'Unknown',
  [AppEnvironment.Development]: 'Development',
  [AppEnvironment.Testing]: 'Testing',
  [AppEnvironment.Staging]: 'Staging',
  [AppEnvironment.Production]: 'Production'
};
